<style type="text/css">
    .e-mail:before {
        content: attr(data-website) "\0040" attr(data-user);
        unicode-bidi: bidi-override;
        direction: rtl;
    }
</style>

<section id="contact" class="content">
    <div class="wrapper">
        <h2>Oh. You’re still here?</h2>
        <p>
            Shucks. I honestly didn’t think you’d make it this far...
            <br/>
            This is a bit embarrassing; I don’t really have anything prepared.
        </p>
        <p>
            Um, I guess you could check out my designs on <a href="https://dribbble.com/BrodieHamilton">Dribbble</a>,
            follow me on <a href="https://www.instagram.com/brodiehamiltondesign/">Instagram</a>, or even connect <a
                href="https://www.linkedin.com/in/brodiehamilton/">LinkedIn</a>?
            Or heck, go all out and follow me on <a href="https://x.com/brodiedesign">X</a> if you’re that
            desperate.
        </p>

        <p>
            Alternatively, if you would like to get in touch directly, feel free to shoot me an email at
            <a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#119;&#101;&#98;&#64;&#98;&#114;&#111;&#100;&#105;&#101;&#104;&#97;&#109;&#105;&#108;&#116;&#111;&#110;&#46;&#99;&#111;&#109;">
                <span class="e-mail" data-user="bew" data-website="moc.notlimaheidorb" />
            </a>.
        </p>
        <p>
            Yeah. So. This is embarrassing... Should I leave?
            <br/> Actually, no. This is my website. You should leave.
        </p>
    </div>
</section>